import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum EFilterOptions {
  all = 'Все лендинги',
  active = 'Активные',
  unactive = 'Неактивные',
}

interface ProjectFilterState {
  selectedOption: EFilterOptions;
}

const initialState: ProjectFilterState = {
  selectedOption: EFilterOptions.all,
};

export const projectFilterSlice = createSlice({
  name: 'projectFilter',
  initialState,
  reducers: {
    setSelectedOption: (state, action: PayloadAction<EFilterOptions>) => {
      state.selectedOption = action.payload;
    },
  },
});

export const { setSelectedOption } = projectFilterSlice.actions;

export default projectFilterSlice.reducer;
